import React from "react";
import { Link } from "react-router-dom";
import { Compass } from "lucide-react";
import { MainLayout } from "@/layouts/MainLayout";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <MainLayout>
      <div className="mx-auto flex max-w-lg flex-col items-center px-5 py-32 text-center">
        <div className="mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-brand/10 text-brand">
          <Compass className="h-7 w-7" />
        </div>
        <h1 className="font-heading text-5xl font-extrabold tracking-tight text-foreground">
          404
        </h1>
        <p className="mt-3 text-muted-foreground">
          This page wandered off the map. Let's get you back.
        </p>
        <Button asChild className="mt-8 rounded-full bg-brand px-6 hover:bg-brand-hover">
          <Link to="/" data-testid="notfound-home-btn">Back to home</Link>
        </Button>
      </div>
    </MainLayout>
  );
}
